<script lang="ts">
	import { format } from 'svelte-i18n';
	import type { Device } from 'src/types/Device';
	import { devices_settings, devices_status } from 'src/stores';
	import { devices_config } from 'src/configs/devices';
	import { AdvancedCard, Alert, Button } from '@Shelly/shelly-design-system';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import DeviceLabelList from 'src/components/Sidepanel/DeviceViews/DeviceLabelList.svelte';
	import { real_id } from 'src/helpers/interface_helpers';
	import { status_configurator } from 'src/helpers/device_data_helpers';

	export let device: Device;

	const deviceConfig = devices_config?.[device?.type];

	$: status = $devices_status[real_id(device?.id)];
	$: settings = $devices_settings[real_id(device?.id)];

	$: _statusesRaw =
		status?.online && deviceConfig ? status_configurator(status, device, settings) : null;
	$: _statuses = (Array.isArray(_statusesRaw) ? _statusesRaw : []) as any[];
	$: labelList = _statuses.filter((e) => {
		return 'undefined' === typeof e.main && e.name !== 'state';
	});
	$: hasLabels = status?.online && labelList.length > 0;

	$: irDevices = Object.entries(settings || {})
		.filter(([key]) => /^irdevice:2\d{2}$/.test(key))
		.map(([key, config]: [string, { id?: number; name?: string }]) => ({
			key,
			id: config?.id,
			name: config?.name || key,
		}));
</script>

<DeviceViewStateWrapper {device}>
	<div
		slot="staticTop"
		class="label-list-wrapper mb-s d-flex flex-direction-column justify-content-center"
	>
		{#if hasLabels}
			<DeviceLabelList {labelList} />
		{/if}
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>
	<div slot="content">
		{#if irDevices.length === 0}
			<Alert
				type="info"
				class="mb-s"
				isHeadingBold
				heading={$format('ir_controller_no_remotes_title', {
					default: 'No remotes yet',
				})}
			/>
		{:else}
			{#each irDevices as irDevice, i (irDevice.key)}
				<AdvancedCard
					class={i < irDevices.length - 1 ? 'mb-s' : ''}
					title={irDevice.name}
					aria-label={irDevice.name}
					isFocusable
				/>
			{/each}
		{/if}
	</div>
	<div class="flex-full-height justify-content-end" slot="staticBottom">
		<Button
			size="m"
			width="full"
			aria-label={$format('ir_controller_add_remote', { default: 'Add new remote' })}
		>
			{$format('ir_controller_add_remote', { default: 'Add new remote' })}
		</Button>
	</div>
</DeviceViewStateWrapper>
